import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Button from "../../components/Core/Button/Button";
import TextArea from "../../components/Core/TextArea/TextArea";
import Flex from "../../components/Layout/Flex";
import FloatingButtonPanel from "../../components/Shared/FloatingButtonPanel/FloatingButtonPanel";
import Contract, { ContractWithoutCircularRef } from "../../models/Contract";
import { useContract, useUpdateContract } from "../../networking/contract.hooks";

interface Props {
	contract: Contract;
}

const ContractTermsTab: React.FC<Props> = ({ contract }) => {
	const { contract: fallbackContract } = useContract({
		contractId: contract.fallbackContract?.id,
	});

	const { mutate: updateContract } = useUpdateContract();

	const { register, handleSubmit, setValue } = useForm<ContractWithoutCircularRef>({
		mode: "onBlur",
	});

	useEffect(() => {
		setValue("terms", contract.terms || fallbackContract?.terms || "");
	}, [setValue, contract]);

	const { t } = useTranslation();

	const onSubmit = handleSubmit(async (e) => {
		await updateContract({
			contractId: contract.id,
			update: {
				terms: e.terms || "",
			},
		});
	});

	return (
		<div>
			<form onSubmit={onSubmit}>
				<Flex margin="2rem 0 0 0" maxWidth="1000px" direction="column">
					<TextArea
						{...register("terms")}
						label="contract.terms"
						description="contract.termsDesc"
						height="20rem"
						disabled={contract.isDeleted}
					/>
				</Flex>

				{!contract.isDeleted && (
					<FloatingButtonPanel transparent={false}>
						<Button width="9.75rem">{t("SAVE_CHANGES")}</Button>
					</FloatingButtonPanel>
				)}
			</form>
		</div>
	);
};

export default ContractTermsTab;
